module.exports = __webpack_public_path__ + "static/media/Q6.0b175916.jpg";